import { BrowserRouter, Route, Routes } from "react-router-dom"

import { RentPage } from "@/pages/RentPage"

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<RentPage />} />
      </Routes>
    </BrowserRouter>
  )
}
